import { createFileRoute } from '@tanstack/react-router';

import { InvalidWorkspaceFallback } from '@/features/login/ui/invalid-workspace-fallback';

export const Route = createFileRoute('/workspace/$workspaceId/invalid-workspace')({
  component: InvalidWorkspaceFallback,
});
